import React from 'react'

export default function PastEvents() {
  return (
    <div>
       <div class="service_area pb-70">
       {/* <div class="section_title text_center mb-70 ">
              
              <div class="section_main_title">
                <h2>Past <span>Event</span></h2>
              </div>
              <div class="em_bar">
                <div class="em_bar_bg"></div>
              </div>
        </div> */}
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 event">
            <div class="service_style_two mb-4">
              <div class="service_style_two_number mr-60 w-30">
              <img src='assets/images/linkedin-banner.webp' className="img-fluid" alt="linkedin-banner"/>
              </div>
           
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="service_style_two mb-4">
           
              <div class="service_style_two_content">
                <div class="service_style_two_title pb-3 mr-50">
                  <h4>Forrester B2B Summit North America</h4>
                </div>
                <div class="service_style_two_text mr-50">
                  <p className='mr-70'>
                  Proud Sponsor. Proven Innovator. Future-Driven.
                  </p>
                   <div class="button three past-event mr-250 pt-4">
                <a href="/past-event">Know More</a>
              </div> 
                </div>
              </div>
            </div>
          </div>
       
         
      
         
        </div>
      </div>
    </div>
    </div>
  )
}
